import CheckboxGroupWrapper from './CheckboxGroupWrapper'

export default CheckboxGroupWrapper
